// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"0bbabc0f","550":"0eaab614"}[chunkId] + ".chunk.js";
};